import { investorInAvailableRegion } from '@utils/common-methods/common'

export const inAvailableRegion = () => {
  const investor = JSON.parse(localStorage.getItem('investor'))
  return investorInAvailableRegion(investor.country, investor.administrativeAreaLevel1)
}
